// extracted by mini-css-extract-plugin
export default {"bounce":"v_cL","loading":"v_cM","logo-mark-bounce-right":"v_cN","logo-mark-bounce-left":"v_cP"};